import React from 'react';

export function LegendIcon() {
  return (
    <svg viewBox="0 0 16 16" className="h-3.5 w-3.5" fill="none" aria-hidden>
      <rect x="2.5" y="3" width="3" height="3" rx="0.5" fill="currentColor" />
      <path d="M7.5 4.5h6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <rect x="2.5" y="7" width="3" height="3" rx="0.5" fill="currentColor" opacity="0.7" />
      <path d="M7.5 8.5h6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <rect x="2.5" y="11" width="3" height="3" rx="0.5" fill="currentColor" opacity="0.45" />
      <path d="M7.5 12.5h6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}

export default function LegendToggleButton({
  pressed,
  onClick,
  title = 'Show colour legend on the scene',
  className = '',
}) {
  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      aria-pressed={!!pressed}
      className={`m-0 h-5 w-5 shrink-0 inline-flex items-center justify-center rounded-sm border transition-colors ${
        pressed
          ? 'border-yellow-400 bg-yellow-500 text-black'
          : 'border-yellow-600/30 text-yellow-500/80 hover:bg-yellow-500/10 hover:text-yellow-300'
      } ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      <LegendIcon />
    </button>
  );
}
